// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"SignInComponent_wrapper__PRrB4","title":"SignInComponent_title__3QANQ","descWrapper":"SignInComponent_descWrapper__cfCIm","desc":"SignInComponent_desc__r5k4e"};